import React from "react";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

interface InfoTooltipProps {
  title: React.ReactNode;
  iconSize?: number;
  fill?: string;
  [key: string]: unknown;
}

export default function InfoTooltip({
  title,
  iconSize = 14,
  fill = "#000",
  ...props
}: InfoTooltipProps) {
  return (
    <Tooltip title={title}>
      <InfoCircleOutlined
        style={{ fontSize: iconSize, color: fill }}
        {...props}
      />
    </Tooltip>
  );
}
